import type { TFunction } from 'i18next'
import type { AccountType, OrganizationSegment, SignatoryBasis, SubAccountStatus } from '@/types'

export function accountTypeLabel(t: TFunction, type: AccountType): string {
	if (type === 'INDIVIDUAL')   return t('settings.profile.accountType.individual')
	if (type === 'ENTREPRENEUR') return t('settings.profile.accountType.entrepreneur')
	return t('settings.profile.accountType.company')
}

export function organizationSegmentLabel(t: TFunction, segment: OrganizationSegment): string {
	const map: Record<OrganizationSegment, string> = {
		PRIVATE_LANDLORD:   t('settings.team.segment.privateLandlord'),
		MANAGEMENT_COMPANY: t('settings.team.segment.managementCompany'),
		AGENCY:             t('settings.team.segment.agency'),
	}
	return map[segment]
}

export function subAccountStatusLabel(t: TFunction, status: SubAccountStatus): string {
	if (status === 'ACTIVE')  return t('settings.team.status.active')
	if (status === 'INVITED') return t('settings.team.status.invited')
	return t('settings.team.status.blocked')
}

export function subAccountStatusBadgeVariant(status: SubAccountStatus): 'success' | 'warning' | 'destructive' {
	if (status === 'ACTIVE')  return 'success'
	if (status === 'INVITED') return 'warning'
	return 'destructive'
}

export function signatoryBasisLabel(t: TFunction, basis: SignatoryBasis | undefined): string | undefined {
	if (!basis) return undefined
	const map: Record<SignatoryBasis, string> = {
		PERSONAL:          t('settings.profile.contract.basisPersonal'),
		POWER_OF_ATTORNEY: t('settings.profile.contract.basisPowerOfAttorney'),
		CHARTER:           t('settings.profile.contract.basisCharter'),
		OTHER:             t('settings.profile.contract.basisOther'),
	}
	return map[basis]
}
